/**
 * Boxful Fulfillment 2026 home page - courier rate calculator by box size
 * Source design: boxful_app/ (static mockup)
 */

// Courier Size & Rate Calculator Engine
function calculateBestCourier(event) {
  if (event) event.preventDefault();

  const w = parseFloat(document.getElementById('boxW').value) || 25;
  const d = parseFloat(document.getElementById('boxD').value) || 20;
  const h = parseFloat(document.getElementById('boxH').value) || 15;
  const weight = parseFloat(document.getElementById('boxWeight').value) || 2;
  const volume = parseInt(document.getElementById('monthlyVolume').value) || 1000;

  const totalSize = w + d + h;

  // Determine Size Category
  let categoryName = '';
  let standardCJ = 2500, boxfulCJ = 1950;
  let standardLotte = 2400, boxfulLotte = 1980;
  let standardHanjin = 2450, boxfulHanjin = 2000;
  let standardPost = 3200, boxfulPost = 2700;

  if (totalSize <= 80 && weight <= 2) {
    categoryName = currentLang === 'en' ? 'Ultra-Small (~80cm / 2kg)' :
                   currentLang === 'vi' ? 'Siêu nhỏ (~80cm / 2kg)' :
                   currentLang === 'ru' ? 'Сверхмалый (~80см / 2кг)' :
                   currentLang === 'ja' ? '極小規格 (~80cm / 2kg)' : '극소 규격 (80cm / 2kg 이하)';
    standardCJ = 2500; boxfulCJ = 1950;
    standardLotte = 2400; boxfulLotte = 1980;
    standardHanjin = 2450; boxfulHanjin = 2000;
    standardPost = 3200; boxfulPost = 2700;
  } else if (totalSize <= 100 && weight <= 5) {
    categoryName = currentLang === 'en' ? 'Small (~100cm / 5kg)' :
                   currentLang === 'vi' ? 'Nhỏ (~100cm / 5kg)' :
                   currentLang === 'ru' ? 'Малый (~100см / 5kg)' :
                   currentLang === 'ja' ? '小規格 (~100cm / 5kg)' : '소 규격 (100cm / 5kg 이하)';
    standardCJ = 3000; boxfulCJ = 2450;
    standardLotte = 2900; boxfulLotte = 2480;
    standardHanjin = 2950; boxfulHanjin = 2500;
    standardPost = 4000; boxfulPost = 3300;
  } else if (totalSize <= 120 && weight <= 10) {
    categoryName = currentLang === 'en' ? 'Medium (~120cm / 10kg)' :
                   currentLang === 'vi' ? 'Vừa (~120cm / 10kg)' :
                   currentLang === 'ru' ? 'Средний (~120см / 10kg)' :
                   currentLang === 'ja' ? '中規格 (~120cm / 10kg)' : '중 규격 (120cm / 10kg 이하)';
    standardCJ = 3800; boxfulCJ = 3000;
    standardLotte = 3700; boxfulLotte = 3050;
    standardHanjin = 3750; boxfulHanjin = 3100;
    standardPost = 5000; boxfulPost = 4200;
  } else if (totalSize <= 140 && weight <= 15) {
    categoryName = currentLang === 'en' ? 'Medium-Large (~140cm / 15kg)' :
                   currentLang === 'vi' ? 'Trung lớn (~140cm / 15kg)' :
                   currentLang === 'ru' ? 'Средне-крупный (~140см / 15kg)' :
                   currentLang === 'ja' ? '中大規格 (~140cm / 15kg)' : '중대형 규격 (140cm / 15kg 이하)';
    standardCJ = 4800; boxfulCJ = 3900;
    standardLotte = 4700; boxfulLotte = 3950;
    standardHanjin = 4600; boxfulHanjin = 3850;
    standardPost = 6200; boxfulPost = 5300;
  } else {
    categoryName = currentLang === 'en' ? 'Large (~160cm / 20kg)' :
                   currentLang === 'vi' ? 'Lớn (~160cm / 20kg)' :
                   currentLang === 'ru' ? 'Крупный (~160см / 20kg)' :
                   currentLang === 'ja' ? '大規格 (~160cm / 20kg)' : '대형 규격 (160cm / 20kg 이하)';
    standardCJ = 5900; boxfulCJ = 4800;
    standardLotte = 5800; boxfulLotte = 4850;
    standardHanjin = 5700; boxfulHanjin = 4750;
    standardPost = 7500; boxfulPost = 6500;
  }

  const couriers = [
    {
      name: 'CJ Logistics (CJ대한통운)',
      standardRate: standardCJ,
      negotiatedRate: boxfulCJ,
      badge: currentLang === 'en' ? 'Boxful Top Choice 🏆' :
             currentLang === 'vi' ? 'Lựa chọn #1 Boxful 🏆' :
             currentLang === 'ru' ? 'Выбор №1 Boxful 🏆' :
             currentLang === 'ja' ? 'Boxful最安値1位 🏆' : 'Boxful 최저가 1위 🏆'
    },
    {
      name: 'Lotte Global Logistics (롯데택배)',
      standardRate: standardLotte,
      negotiatedRate: boxfulLotte,
      badge: currentLang === 'en' ? 'Small Box Recommended ⭐' :
             currentLang === 'vi' ? 'Khuyên dùng cho hộp nhỏ ⭐' :
             currentLang === 'ru' ? 'Рекомендовано для малых ⭐' :
             currentLang === 'ja' ? '小型ボックス推奨 ⭐' : '소형 박스 추천 ⭐'
    },
    {
      name: 'Hanjin Logistics (한진택배)',
      standardRate: standardHanjin,
      negotiatedRate: boxfulHanjin,
      badge: currentLang === 'en' ? 'Great Mid-Size Value 👍' :
             currentLang === 'vi' ? 'Giá trị cỡ vừa tuyệt vời 👍' :
             currentLang === 'ru' ? 'Выгода на средние грузы 👍' :
             currentLang === 'ja' ? '中型高コスパ 👍' : '중대형 가성비 우수 👍'
    },
    {
      name: 'Korea Post (우체국택배)',
      standardRate: standardPost,
      negotiatedRate: boxfulPost,
      badge: currentLang === 'en' ? 'Stable Delivery 📬' :
             currentLang === 'vi' ? 'Vận chuyển ổn định 📬' :
             currentLang === 'ru' ? 'Надежная доставка 📬' :
             currentLang === 'ja' ? '安定配送網 📬' : '안정 배송망 📬'
    }
  ];

  // Sort by Boxful negotiated rate
  couriers.sort((a, b) => a.negotiatedRate - b.negotiatedRate);
  const bestCourier = couriers[0];
  const totalStandard = bestCourier.standardRate * volume;
  const totalNegotiated = bestCourier.negotiatedRate * volume;
  const monthlySavings = totalStandard - totalNegotiated;

  // Update UI Elements
  const resTotalSize = document.getElementById('resTotalSize');
  const resWeight = document.getElementById('resWeight');
  const bestCourierName = document.getElementById('bestCourierName');
  const savingsNotice = document.getElementById('savingsNotice');

  if (resTotalSize) resTotalSize.innerText = totalSize;
  if (resWeight) resWeight.innerText = weight;
  
  if (bestCourierName) {
    const wonSymbol = '₩';
    bestCourierName.innerHTML = `${bestCourier.name} (${wonSymbol}<strong>${bestCourier.negotiatedRate.toLocaleString()}</strong> / ${(bestCourier.standardRate - bestCourier.negotiatedRate).toLocaleString()} ${wonSymbol} saved/ea)`;
  }
  if (savingsNotice) {
    savingsNotice.innerHTML = currentLang === 'en' ? `Estimated monthly logistics savings for ${volume.toLocaleString()} orders: <strong style="color: #00C6B2; font-size: 16px;">₩${monthlySavings.toLocaleString()}</strong>!` :
                              currentLang === 'vi' ? `Ước tính tiết kiệm chi phí hàng tháng cho ${volume.toLocaleString()} đơn: <strong style="color: #00C6B2; font-size: 16px;">₩${monthlySavings.toLocaleString()}</strong>!` :
                              currentLang === 'ru' ? `Оценочная экономия в месяц при ${volume.toLocaleString()} заказах: <strong style="color: #00C6B2; font-size: 16px;">₩${monthlySavings.toLocaleString()}</strong>!` :
                              currentLang === 'ja' ? `月${volume.toLocaleString()}件出荷時の予想削減額: <strong style="color: #00C6B2; font-size: 16px;">₩${monthlySavings.toLocaleString()}</strong>!` :
                              `월 ${volume.toLocaleString()}건 출고 시 약 <strong style="color: #00C6B2; font-size: 16px;">${monthlySavings.toLocaleString()}원</strong>의 순수 물류비가 절감됩니다!`;
  }

  const tbody = document.getElementById('courierTableBody');
  if (tbody) {
    tbody.innerHTML = '';
    couriers.forEach((c, idx) => {
      const isTop = idx === 0;
      const monthlyTotal = c.negotiatedRate * volume;
      const tr = document.createElement('tr');
      if (isTop) tr.className = 'highlight-row';

      tr.innerHTML = `
        <td><strong>${c.name}</strong> ${isTop ? '<span style="color: #00C6B2; font-size: 11px; margin-left: 4px;">● BEST</span>' : ''}</td>
        <td>${categoryName}</td>
        <td><span style="text-decoration: line-through; color: #94A3B8;">₩${c.standardRate.toLocaleString()}</span></td>
        <td><strong style="color: ${isTop ? '#008F80' : '#0F172A'}; font-size: 15px;">₩${c.negotiatedRate.toLocaleString()}</strong></td>
        <td>₩${monthlyTotal.toLocaleString()}</td>
        <td><span class="result-tag" style="background: ${isTop ? '#00C6B2' : '#64748B'}; color: #fff;">${c.badge}</span></td>
      `;
      tbody.appendChild(tr);
    });
  }

  const calcResult = document.getElementById('calcResult');
  if (calcResult) calcResult.classList.remove('hidden');
}
